import { Component, ElementRef, HostBinding, Input, OnDestroy, ViewChild } from "@angular/core";
import { ToolbarItem } from "common/toolbar/toolbar-item.interface";
import { UtilService } from "common/util.service";
import { ZoomToolbarService } from "common/zoom/zoom-toolbar/zoom-toolbar.service";
import { PreferencesService } from "core/preferences.service";
import { Subscription } from "rxjs";

const MINIMAL_COLLAPSIBLE_CARD_HEIGHT = "72px";

@Component({
	selector: "stages-card",
	templateUrl: "./card.component.html",
	providers: [ZoomToolbarService],
})
export class CardComponent implements OnDestroy {
	@Input()
	toolbarId?: string;

	@Input()
	toolbarItems: ToolbarItem[] = [];

	@Input()
	menuId?: string;

	@Input()
	menuItems: MenuItem[] = [];

	@Input()
	menuNoCollapse?: boolean;

	// needed to to toggle child component and to detect if
	// a card menu function has to be force triggered
	@Input()
	externalToggleFunctions: MenuItem[] = [];

	@Input()
	contentCollapsible?: boolean;

	@Input()
	showCollapseOption?: boolean;

	@Input()
	showHeader: boolean = true;

	@ViewChild("tabsContainer")
	tabsContainer?: ElementRef;

	// To collapse the card till the headline,
	// you have to change the min-height attribute
	@HostBinding("style.min-height")
	minHeight = "";

	@HostBinding("style.transition")
	transition = "";

	expanded: boolean = true;
	title?: string;
	showZoomToolbar: boolean = false;
	private subscription?: Subscription;
	isIE: boolean = false;

	constructor(
		readonly zoomToolbarService: ZoomToolbarService,
		readonly preferencesService: PreferencesService,
		readonly utilService: UtilService,
		readonly cardElementRef: ElementRef,
	) {
		if (this.zoomToolbarService.isBrowserSupported) {
			this.subscription = this.zoomToolbarService.amountOfVisibleDiagrams.subscribe({
				next: (value) => (this.showZoomToolbar = value > 0),
			});
			this.zoomToolbarService.applyZoomParametersFromLocalStorage();
		}
		this.isIE = utilService.browserIsIE();
	}

	resetHeight(): void {
		this.minHeight = this.contentCollapsible ? MINIMAL_COLLAPSIBLE_CARD_HEIGHT : "";
	}

	toggleContentView(): void {
		if (this.externalToggleFunctions.length > 0) {
			this.expanded = !this.expanded;
			this.externalToggleFunctions.forEach((externalToggle) => externalToggle.on());
			this.resetHeight();
		}
	}

	// Expands the content that is collapsed by toggle function
	forceShowContent(): void {
		if (!this.expanded) {
			this.toggleContentView();
		}
	}

	getHeight(): number {
		return this.cardElementRef.nativeElement.offsetHeight;
	}

	setHeight(newHeight: string): void {
		this.minHeight = newHeight;
	}

	activateTransition(): void {
		this.transition = "min-height 0.3s 0s cubic-bezier(0.4, 0, 0.2, 1)";
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
